jQuery(document).ready(function () {
	var post_id = window.seats_modal_vars.current_post_id;

	if(post_id === undefined || post_id === null) {
		return;
	}

	if (getCookie('modal_shown') === 'true') {
		return;
	}

	jQuery.ajax({
		dataType: "json",
		url: window.seats_modal_vars.result_route + '/' + post_id,
		method: 'GET',
		success: function (res) {
			if (res.success === undefined) {
				return;
			}

			var content = res.results.popup_content,
				title = res.results.popup_title ? res.results.popup_title : '',
				show_modal = res.results.show_modal,
				days_interval = res.results.popup_interval;

			if (show_modal) {
				fillModal(title, content);
				if (days_interval > 0) {
					setCookie('modal_shown', true, days_interval);
				}
			}
		}
	});

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		console.log('setting cookie')
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	function fillModal(title, content) {
		jQuery('html').append(
			'<div class="modal fade" tabindex="-1" role="dialog" id="popupModal">' +
			'<div class="modal-dialog" role="document">' +
			'<div class="modal-content">' +
			'<div class="modal-header">' +
			'<h5 class="modal-title">' + title + '</h5>' +
			'<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
			'<span aria-hidden="true">&times;</span>' +
			'</button>' +
			'</div>' +
			'<div class="modal-body">' +
			content +
			'</div>' +
			'</div>' +
			'</div>' +
			'</div>');

		jQuery('#popupModal').modal('show');
	}

});